import { StripeCardNumberElementOptions } from "@stripe/stripe-js";
import { useMemo } from "react";

const useOptionsStripe = (): StripeCardNumberElementOptions => {
    return useMemo(
        () => ({
            style: {
                base: {
                    fontFamily: "GeneralSans-Regular, sans-serif",
                    fontSize: "16px",
                    color: "#777e91",
                    "::placeholder": {
                        color: "#777e91",
                    },
                    padding: "0.5rem",
                    lineHeight: "25.6px",
                },
                invalid: {
                    color: "#777e91",
                },
            },
            showIcon: true,
        }),
        []
    );
};

export default useOptionsStripe;
